import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-loader",
  template: `
    <div id="skeleton-loader" class="loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  `,
  styles: [
    `
      .loader {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .dot {
        width: 16px;
        height: 16px;
        margin: 0 4px;
        background-color: #333;
        border-radius: 50%;
        animation: chase 1.5s infinite;
      }

      .dot:nth-child(1) {
        animation-delay: -0.32s;
      }

      .dot:nth-child(2) {
        animation-delay: -0.16s;
      }

      @keyframes chase {
        0%,
        80%,
        100% {
          opacity: 0;
        }
        40% {
          opacity: 1;
        }
      }
    `,
  ],
})
export class SkeletonLoaderComponent {}
